export default __webpack_public_path__ + "static/infrastructure-d4f9354e2299d04e8821ea3de13f9ae2.jpg";